module.exports = {"title":"Bergrede XIII","date":"2013-04-01T00:00:00Z","layout":"post","attachment":"Bergrede_XIII_Blog.pdf","linktext":"Lees bergrede","body":"<p>De tekst die Sylvain De Bleeckere heeft uitgesproken bij de <strong>22ste editie van De Dag van de Religieuze Film</strong> met als thema: <strong>Bergrede XIII</strong>.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./blog/2015-01-08-BergredeXIII/index.md
// module id = 970
// module chunks = 0